import { useTranslation } from 'react-i18next';

import { CloudUpload as Icon } from '@mui/icons-material';

import FloatIcon from 'components/icons/FloatIcon';

function ImportIcon({ onImport }: { onImport: () => any }) {
	const { t } = useTranslation();

	return <FloatIcon onClick={() => onImport()} title={t('common:import')} icon={Icon} />;
}

export default ImportIcon;
